import React from 'react'
import { useAppSelector } from 'reduxTyped'
import { BtnV2, l } from '@manychat/manyui'

import {
  AvailableForRegistrationChannel,
  RegistrationSection,
} from 'apps/registration/interfaces/registration'
import { alert } from 'common/core'
import { ChannelType, ChannelTypeLabel } from 'common/core/constants/ChannelType'
import { getCurrentAccount } from 'common/core/selectors/appSelectors'
import { typedRouting } from 'utils/router'
import { getLocation, navigatePollyfill } from 'utils/router/tools'
import { analyticsService } from 'utils/services/analytics'
import { linkURL } from 'utils/url'

const ChannelAlertContent = ({ channelType }) => {
  return (
    <span>
      <span>
        {l.translate('Running this flow requires {channel} channel. Please go to', {
          channel: ChannelTypeLabel[channelType],
        })}
      </span>
      <BtnV2
        className="text-white m-l-xxs m-r-xxs"
        style={{ 'text-decoration': 'underline' }}
        onClick={() => navigatePollyfill(linkURL(`/settings#${channelType.toLowerCase()}`))}
      >
        {`${l.translate('Settings')} -> ${ChannelTypeLabel[channelType]}`}
      </BtnV2>
      <span>{l.translate('to enable it.')}</span>
    </span>
  )
}

// eslint-disable-next-line react/no-multi-comp
const FBAlertContent = () => {
  const { page_id } = useAppSelector(getCurrentAccount)
  const { pathname, hash } = getLocation()
  const returnUri = pathname + hash
  const href = typedRouting.linkBuilder.registration({
    section: RegistrationSection.CHANNEL_CONNECTION,
    channel: AvailableForRegistrationChannel.FACEBOOK,
    accountId: page_id,
    returnUri,
  })
  return (
    <span>
      {l.translate(
        `Running this flow requires Facebook page. Please use <a class="text-primary m-l-xxs m-r-xxs" onclick="handleClick" href="{href}">this link</a> to connect.`,
        {
          href,
          handleClick: () =>
            analyticsService.sendEvent('CONNECT_CHANNEL.CLICK', {
              channel: ChannelType.FB,
              source: 'flow_channel_connect_required_alert',
            }),
        },
      )}
    </span>
  )
}

export const alertChannelRequired = (channelType) => {
  let AlertContent
  let warningType = 'info'

  switch (channelType) {
    case ChannelType.EMAIL:
    case ChannelType.SMS:
      AlertContent = ChannelAlertContent
      warningType = 'danger'
      break
    case ChannelType.FB:
      AlertContent = FBAlertContent
      break
  }

  if (!AlertContent) {
    return
  }

  alert('', warningType, { content: <AlertContent channelType={channelType} /> })
}
